import { apiBaseUrl, scApiBaseUrl } from 'yxt-biz-pc/packages/api';

const api = (window.feConfig && window.feConfig.apiEnv === 'tf-ali-01') ? scApiBaseUrl : apiBaseUrl;

/**
 * 检索项目信息
 * @param {*} param
 * param:{
 *  current: 当前页
 *  orderKey: 排序key值
 *  orderSort: 练习次数排序 枚举: 升序:asc 降序:desc
 *  projectName: 搜索条件：项目名称
 *  size: 每页显示数量
 * }
 * @returns
 */
export const queryProject = param => {
  return api.get('/sparring/report-form/projects/rtp-search', param);
};

// 获取分类树列表
export const getCategories = () => {
  return api.get('/sparring/categories/trees');
};
